export const SCROLL_BAR_WIDTH = 20;
